import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import CopyTextField from 'cityads-v3/components/CopyTextField/CopyTextField';

import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils';

import {
  getOAuth2Credentials,
  changeOAuth2Credentials,
} from 'cityads-v3/actions/apiAuth';

import classes from './OAuth.scss';

@connect(
  state => ({
    clientId    : state.apiAuth.oauth2ClientId,
    clientSecret: state.apiAuth.oauth2ClientSecret,
    isLoading   : state.apiAuth.isOauth2CredentialsLoading,
    isLoaded    : state.apiAuth.isOauth2CredentialsLoaded,
    isChanging  : state.apiAuth.isOauth2CredentialsChanging,
    errors      : state.apiAuth.oauth2CredentialsChangingErrors,
  }),
  dispatch => bindActionCreators({
    getOAuth2Credentials,
    changeOAuth2Credentials,
  }, dispatch),
)
@withTranslation(['Publisher'], { i18n, wait: !!window })
export default class OAuth20 extends Component {
  static propTypes = {
    t                      : PropTypes.func.isRequired,
    clientId               : PropTypes.string,
    clientSecret           : PropTypes.string,
    isLoading              : PropTypes.bool,
    isLoaded               : PropTypes.bool,
    getOAuth2Credentials   : PropTypes.func.isRequired,
    changeOAuth2Credentials: PropTypes.func.isRequired,
    isChanging             : PropTypes.bool,
    errors                 : PropTypes.arrayOf(PropTypes.string),
  }

  componentDidMount() {
    const { isLoading, isLoaded, getOAuth2Credentials } = this.props;

    if (!isLoading && !isLoaded) {
      getOAuth2Credentials();
    }
  }

  renderUninitialized() {
    const { t, changeOAuth2Credentials, isChanging, errors } = this.props;

    return (
      <div className={classes.registerCard}>
        <div className={classes.registerText}>
          {t('api.oauthForm.registerText')}
        </div>

        <div className={classes.buttonContainer}>
          <Button
            variant   = "contained"
            color     = "primary"
            className = {classes.button}
            onClick   = {changeOAuth2Credentials}
            disabled  = {isChanging}
          >
            {t('api.oauthForm.registerButton')}
          </Button>
          {isChanging ? <CircularProgress size={24} className={classes.buttonProgress} /> : null}
        </div>

        {(errors && errors.length) ? (
          <div className={classes.errors}>
            {errors.map((err, idx) => (
              <div className={classes.error} key={idx}>
                {err}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }

  renderChangeButton() {
    const { t, changeOAuth2Credentials, isChanging, errors } = this.props;

    return (
      <>
        <div className={classes.buttonContainer}>
          <Button
            id        = "apiPageOauth20ChangeButton"
            variant   = "contained"
            color     = "primary"
            className = {classes.button}
            onClick   = {changeOAuth2Credentials}
            disabled  = {isChanging}
          >
            {t('api.oauthForm.button')}
          </Button>
          {isChanging ? <CircularProgress size={24} className={classes.buttonProgress} /> : null}
        </div>

        {(errors && errors.length) ? (
          <div className={classes.errors}>
            {errors.map((err, idx) => (
              <div className={classes.error} key={idx}>
                {err}
              </div>
            ))}
          </div>
        ) : null}
      </>
    );
  }

  render() {
    const { t, clientId, clientSecret, isLoading } = this.props;

    if (isLoading) {
      return (
        <div className={classes.сardLoading}>
          <CircularProgress size={48} />
        </div>
      );
    }

    if (!clientId && !clientSecret) {
      return this.renderUninitialized();
    }

    return (
      <div className={classes.card}>
        <div className={classes.inputContainer}>
          <CopyTextField
            label = {t('api.oauthForm.clientId')}
            value = {clientId || ''}
            copyButtonTitle = {t('main:buttons.copy')}
            onCopyText = {() => {
              amplitudeSendEvent('makeActions', 'd-v1-e17', 'office', 'api_oauth_client_id_copy');
            }}
          />
        </div>

        <div className={classes.inputContainer}>
          <CopyTextField
            id = "apiPageOauth20clientSecretInput"
            label = {t('api.oauthForm.clientSecret')}
            value = {clientSecret || ''}
            copyButtonTitle = {t('main:buttons.copy')}
            onCopyText = {() => {
              amplitudeSendEvent('makeActions', 'd-v1-e18', 'office', 'api_oauth_client_secret_copy');
            }}
          />
        </div>

        {this.renderChangeButton()}

        <div className={classes.note}>
          <div className={classes.attention}>
            {t('api.oauthForm.attention')}
          </div>
          <p>
            {t('api.oauthForm.text1')}
          </p>
        </div>
      </div>
    );
  }
}
